import http from '@http';

class CorrectingActionsService {
    get() {
        return http.get('/api/classifiers/correcting-actions').then((res) => res.data);
    }
}

export const correctingActionsService = new CorrectingActionsService();
